var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',[_c('v-row',{staticClass:"justify-center"},[_c('v-col',{attrs:{"cols":"6"}},[_c('login-form')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }